/* Square owns wishlist persistence. Custom hearts delegate to its mounted buttons. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const page = document.querySelector('[data-tf-wishlist-page]');
  if (page) window.location.replace(root + 'apps/page/wishlist');
  function providerButton(button) {
    const savedCard = button.closest('.Vtl-WishlistProduct');
    if (savedCard) return savedCard.querySelector('.Vtl-WishlistProduct__CloseButton');
    const card = button.closest('[data-tf-card]');
    if (card) {
      const local = card.querySelector('.Vtl-WishlistButton__WishlistIconButton');
      if (local) return local;
      const prefix = 'Vtl-WishlistIcon__Wrapper--Id-' + button.dataset.productId + '-';
      return [...document.querySelectorAll('.Vtl-WishlistIcon__Wrapper')].find(el => [...el.classList].some(c => c.startsWith(prefix)))?.querySelector('.Vtl-WishlistButton__WishlistIconButton');
    }
    return document.querySelector('.Vtl-WishlistButton__AddToWishlist, .Vtl-WishlistButton__RemoveFromWishlist');
  }
  function sync() {
    document.querySelectorAll('[data-tf-wish]').forEach(button => {
      const provider = providerButton(button);
      const label = provider?.getAttribute('aria-label') || provider?.getAttribute('title') || '';
      const saved = Boolean(button.closest('.Vtl-WishlistProduct')) || /remove|added|saved/i.test(label);
      if (provider) {
        if (!button.dataset.tfWishOriginalLabel) button.dataset.tfWishOriginalLabel = button.getAttribute('aria-label') || 'Add to Wishlist';
        const productName = button.closest('[data-tf-card]')?.querySelector('h3')?.textContent.trim();
        const accessibleLabel = saved ? (productName ? `Remove ${productName} from wishlist` : 'Remove from Wishlist') : button.dataset.tfWishOriginalLabel;
        if (button.getAttribute('aria-label') !== accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
        const state = String(saved);
        if (button.getAttribute('aria-pressed') !== state) button.setAttribute('aria-pressed', state);
        if (button.classList.contains('tf-wish-saved') !== saved) button.classList.toggle('tf-wish-saved', saved);
        if (button.title !== label) button.title = label;
      }
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tf-wish]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const provider = providerButton(button);
    if (!provider) {
      if (button.closest('.tf-wishlist-recommendations')) {
        const url = new URL(button.dataset.productUrl, location.origin);
        url.searchParams.set('tallah_wishlist_save', '1');
        location.assign(url.href);
        return;
      }
      button.title = 'Wishlist is loading. Open the product or refresh to try again.';
      const status = button.closest('[data-tf-card]')?.querySelector('[data-tf-error]');
      if (status) { status.hidden = false; status.textContent = button.title; }
      return;
    }
    provider.click();
    sync();
  }, true);
  let frame;
  new MutationObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-label','title','class']});
  sync();
  if (new URL(location.href).searchParams.get('tallah_wishlist_save') === '1') {
    const bridge = document.querySelector('.tf-square-product-bridge');
    if (bridge) {
      bridge.classList.add('tf-wishlist-bridge-active');
      bridge.removeAttribute('aria-hidden');
      const note = document.createElement('p'); note.className = 'tf-wishlist-save-note'; note.setAttribute('role', 'status'); note.textContent = 'Save this product to your wishlist using the heart below.'; bridge.before(note);
      const url = new URL(location.href); url.searchParams.delete('tallah_wishlist_save'); history.replaceState({}, '', url);
      let attempted = false;
      const save = () => {
        const provider = bridge.querySelector('[role="button"][aria-label]');
        if (!provider) return;
        const label = provider.getAttribute('aria-label') || provider.textContent;
        if (/remove|added|saved/i.test(label)) { observer.disconnect(); clearTimeout(timeout); location.assign(root + 'apps/page/wishlist'); return; }
        if (!attempted && /add to wishlist/i.test(label)) {
          attempted = true; note.textContent = 'Saving this product to your wishlist…';
          requestAnimationFrame(() => {
            provider.dispatchEvent(new MouseEvent('mousedown', {bubbles:true}));
            provider.dispatchEvent(new MouseEvent('mouseup', {bubbles:true}));
            provider.click();
          });
        }
      };
      const observer = new MutationObserver(save);
      observer.observe(bridge, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-label','class']});
      const timeout = setTimeout(() => { observer.disconnect(); note.textContent = 'Tap Add to Wishlist below to save this product.'; }, 15000);
      save();
    }
  }
})();
